export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq'
  },
  // {
  //   field: 'col-opt',
  //   title: that.$l('INDEX.table_label_operation') || '操作',
  //   headerAlign: 'center',
  //   align: 'center',
  //   width: 140,
  //   slots: {
  //     default: 'opt'
  //   }
  // },
  {
    title: that.$l('table_label_planned_date') || '计划日期',
    field: 'scheduleDate',
    align: 'center',
    minWidth: 170,
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_planned_quantity') || '计划数量',
    field: 'planQty',
    minWidth: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_scheduled_production') || '已排产数量',
    field: 'schedulingQty',
    minWidth: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_completed_quantity') || '已完成数量',
    field: 'finishQty',
    minWidth: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true
  },
  {
    field: 'modifyByName',
    align: 'center',
    minWidth: 100,
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    showHeaderOverflow: true
  },
  {
    field: 'modifyDate',
    align: 'center',
    minWidth: 170,
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    showHeaderOverflow: true
  }
]
